var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../../services/preferences.service';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { SCREEN_SIZE } from '../../../classes/enums';
import { caraBoardPartialName, victoriaRealEstate, EdmontonBoard } from '../../../app-config.constants';
import { CacheService } from '../../../services/cache.service';
import { ListingsService } from '../../../services/listings.service';
import { ADD_SAVED_LISTING_PREVIEW_GTM, ADD_SAVED_LANDING_PAGE_GTM } from '../../../classes/analytics-tags';
import { Router } from '@angular/router';
var ListingCardComponent = /** @class */ (function (_super) {
    __extends(ListingCardComponent, _super);
    function ListingCardComponent(_preferencesService, _listingService, _router, communicationService, cache, translate) {
        var _this = _super.call(this) || this;
        _this._preferencesService = _preferencesService;
        _this._listingService = _listingService;
        _this._router = _router;
        _this.communicationService = communicationService;
        _this.cache = cache;
        _this.translate = translate;
        _this.confirmUnfavourite = false;
        _this.currentSlideIndex = 0; // Which image they're on in the image carousel
        _this.isSelectedCard = false;
        _this.isNextCard = false;
        _this.includeAddress = true;
        _this.isListingDetails = false; //  the card is used in multiple places, using the listing.isLuxury would change the design across all those places
        _this.isLandingPageListing = false; // Whether or not its a listing on the landing page, we really only need this for Google Tag Manager
        _this.isMapView = false; // checks whether or not rm-carousel should prefetch images
        _this.isRedesign = false;
        _this.unfavourited = new EventEmitter();
        _this.click = new EventEmitter();
        _this.onFocus = new EventEmitter();
        _this.onHoverListingCard = new EventEmitter();
        _this.changeCarouselIndex = new EventEmitter();
        _this.showShare = false;
        _this.highlight = false;
        _this.isVictoriaRealEstateBoard = false;
        _this.isCaraBoard = false;
        _this.isEdmontonBoard = false;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
    }
    // Adding comment
    ListingCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isVictoriaRealEstateBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(victoriaRealEstate) !== -1 && !this.listing.isRemaxListing;
        this.isCaraBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(caraBoardPartialName) !== -1; //&& !this.listing.isRemaxListing;
        this.isEdmontonBoard = this.listing.boardName && this.listing.boardName.toLowerCase() === EdmontonBoard;
        this.setPriceOrPricePerSqFt();
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) { return _this.screenSize = screenSize; }));
    };
    ListingCardComponent.prototype.ngOnChanges = function (changes) {
        if (changes.listing) {
            this.setPriceOrPricePerSqFt();
        }
    };
    ListingCardComponent.prototype.openPrintListingPage = function ($event) {
        var _this = this;
        $event.preventDefault();
        $event.stopPropagation();
        this._router.navigate([]).then(function (result) {
            window.open('/print-listing/' + _this.listing.listingId, '_blank');
        });
    };
    ListingCardComponent.prototype.setPriceOrPricePerSqFt = function () {
        var _this = this;
        this.addSub(this._listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(function (str) { return _this.priceOrPricePerSqFt = str; }));
    };
    ListingCardComponent.prototype.listingCardClicked = function (navigate) {
        // Save the listingId for later so when we come back to the map we can open the carousel and show the listing.
        this.cache.set(this.cache.KeySelectedListingId, this.listing.listingId, 300, true);
        this.click.emit(this.listing.listingId);
        // TODO: Check this, clicking on the image listing does a URL change outside of angular
        // if (!this.showMap) {
        //   this._router.navigate([this.listing.detailUrl]);
        // }
    };
    ListingCardComponent.prototype.toggleFavourite = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        var confirmation = this.translate.instant('notification.confirm-remove-saved');
        if (this.confirmUnfavourite && this.listing.isFavourite && !confirm(confirmation))
            return;
        this.listing.isFavourite = !this.listing.isFavourite;
        this._preferencesService.toggleFavouriteListing(this.listing.listingId, this.isLandingPageListing ? ADD_SAVED_LANDING_PAGE_GTM : ADD_SAVED_LISTING_PREVIEW_GTM);
        this.listing.getFavouriteIconToUse();
        if (!this.listing.isFavourite) {
            this.unfavourited.emit();
        }
    };
    ListingCardComponent.prototype.showHideShare = function (event) {
        event.stopPropagation();
        this.showShare = !this.showShare;
    };
    ListingCardComponent.prototype.setHighlight = function (listingId) {
        this.highlight = this.listing.listingId === listingId;
        if (this.highlight) {
            this.card.nativeElement.scrollIntoView(true);
        }
    };
    ListingCardComponent.prototype.getFavouriteIcon = function () {
        // Show the red heart icon in commercial listing details, otherwise use the default favourite icons
        return this.listing.isCommercial ?
            (this.listing.isFavourite ? '/assets/icons/heart/heart_icon_red@2x.svg' : 'assets/icons/heart/heart_icon_commercial.svg') :
            this.listing.favouriteIconToUse;
    };
    return ListingCardComponent;
}(HasSubscriptions));
export { ListingCardComponent };
